import { h, computed } from 'vue'
import './style.scss'

const AAvatar = {
    name: 'AAvatar',
    props: {
        src: {
            type: String,
            default: '',
        },
        alt:{
            type: String,
            default: '',
        },
        title:{
            type: String,
            default: '',
        },
        width: {
            default: '',
        }
    },
    setup: (props, ctx) => {

        const styles = computed(() => {
            let data = {}
            if(props.width) {
                data.width = `${props.width}px`
                data.height = `${props.width}px`
            }

            return data
        })


        const renderView = () =>
            h('div', {
                class: ['a-avatar'],
            }, h('div', {
                class: ['a-avatar__inner'],
                style: styles.value,
            }, [
                h('img', {
                    src: props.src,
                    alt: props.alt,
                    title: props.title,
                }),
            ]))

        return {
            renderView
        }
    },
    render() {
        return this.renderView()
    },
}

export { AAvatar }
